import { useState, useEffect, useCallback, Fragment } from 'react';
import api from '../api';

const nf = new Intl.NumberFormat('ru-RU');
const n0 = v => (v == null ? '—' : nf.format(Math.round(Number(v))));
const n2 = v => (v == null ? '—' : nf.format(Math.round(Number(v) * 100) / 100));
const ctrOf = (c, v) => (v > 0 ? (c * 100 / v).toFixed(2) : '—');
const posOf = v => (v == null ? '—' : String(Math.round(v * 10) / 10));
const fmtD = d => d.slice(8, 10) + '.' + d.slice(5, 7);
const nk = s => String(s || '').toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
const yesterday = () => new Date(Date.now() + 3 * 3600000 - 86400000).toISOString().slice(0, 10);

let FQ = {};
let EX = {};
const COLS = [
  ['freq', 'Частота (мес.)'], ['views', 'Показы'], ['clicks', 'Клики'], ['ctr', 'CTR, %'], ['baskets', 'Корзины'],
  ['orders', 'Заказы'], ['spend', 'Расход, ₽'], ['avg_pos', 'Ср. поз.'],
];
const WCOLS = [['views', 'Показы'], ['clicks', 'Клики'], ['ctr', 'CTR, %'], ['baskets', 'Корзины'],
  ['orders', 'Заказы'], ['spend', 'Расход, ₽'], ['avg_pos', 'Ср. поз.']];
function aggr(list, ds) {
  const t = { views: 0, clicks: 0, baskets: 0, orders: 0, spend: 0 };
  let pw = 0, pv = 0;
  list.forEach(r => ds.forEach(d => {
    const x = r.byDay && r.byDay[d];
    if (!x) return;
    t.views += x.views || 0; t.clicks += x.clicks || 0; t.baskets += x.baskets || 0;
    t.orders += x.orders || 0; t.spend += x.spend || 0;
    if (x.avg_pos != null && x.views > 0) { pw += x.avg_pos * x.views; pv += x.views; }
  }));
  t.avg_pos = pv > 0 ? pw / pv : null;
  return t;
}
const GROUP_B = '3px solid rgba(128,128,128,.85)';
const WSORT = [['views', 'Показы'], ['clicks', 'Клики'], ['ctr', 'CTR'], ['baskets', 'Корзины'],
  ['orders', 'Заказы'], ['spend', 'Расход'], ['freq', 'Частота']];
const PERIODS = [3, 7, 14, 30];
const cell = { padding: '5px 8px', borderBottom: '1px solid rgba(128,128,128,.2)', textAlign: 'right', whiteSpace: 'nowrap' };
const c11 = { ...cell, padding: '1px 5px' };
const btn = (on) => ({ padding: '3px 10px', borderRadius: 6, border: '1px solid rgba(128,128,128,.4)', cursor: 'pointer',
  background: on ? 'rgba(59,130,246,.25)' : 'transparent', color: 'inherit' });
const val = (r, k) => (k === 'freq' ? ((FQ[r.cluster] && FQ[r.cluster].freq != null) ? FQ[r.cluster].freq : -1) : k === 'ctr' ? (r.views > 0 ? r.clicks / r.views : -1) : (r[k] == null ? -1 : r[k]));

function show(r, k) {
  if (k === 'freq') {
    const f = FQ[r.cluster];
    if (!f) return '—';
    if (f.freq != null) return n0(f.freq);
    return f.freq_checked ? 'нет данных' : '…';
  }
  if (k === 'views' || k === 'clicks' || k === 'baskets' || k === 'orders') return n0(r[k]);
  if (k === 'ctr') return ctrOf(r.clicks, r.views);
  if (k === 'spend') return n2(r.spend);
  return posOf(r.avg_pos);
}

export default function ClustersPanel({ nmId, alwaysOpen, onAdded }) {
  const [open, setOpen] = useState(!!alwaysOpen);
  const [mode, setMode] = useState('week');
  const [days, setDays] = useState(7);
  const [day, setDay] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [sort, setSort] = useState({ key: 'views', dir: -1 });
  const [exp, setExp] = useState({});
  const [q, setQ] = useState('');
  const [have, setHave] = useState(new Set());
  const [msg, setMsg] = useState('');
  const reqDays = mode === 'day' ? 30 : mode === 'week' ? 8 : days;

  const load = useCallback(async () => {
    if (!nmId) return;
    setLoading(true); setErr('');
    try {
      const r = await api.get('/positions/clusters', { params: { nmId, days: reqDays } });
      FQ = {};
      EX = {};
      (r.data.clusters || []).forEach(c => { FQ[c.cluster] = c; EX[c.cluster] = !!c.excluded; });
      setData(r.data);
      const ds = r.data.dates || [];
      setDay(prev => (prev && ds.includes(prev) ? prev : (ds.length ? ds[ds.length - 1] : null)));
      try {
        const kr = await api.get('/positions/keywords', { params: { nmId } });
        const arr = Array.isArray(kr.data) ? kr.data : ((kr.data && kr.data.keywords) || []);
        setHave(new Set(arr.map(k => nk(k.keyword || k))));
      } catch (e2) { /* список ключей необязателен */ }
    } catch (e) { setErr('Не удалось загрузить: ' + (e.message || e)); }
    setLoading(false);
  }, [nmId, reqDays]);

  useEffect(() => { if (open) load(); }, [open, load]);

  const add = async (name) => {
    setMsg('');
    try {
      await api.post('/positions/keywords', { nmId, keyword: name });
      setHave(h => { const n = new Set(h); n.add(nk(name)); return n; });
      if (onAdded) onAdded();
    } catch (e) { setMsg((e.response && e.response.data && e.response.data.error) || e.message || 'ошибка'); }
  };
  const plus = name => (
    have.has(nk(name))
      ? <span title="уже в позициях" style={{ marginRight: 6, color: '#22c55e' }}>✓</span>
      : <button onClick={() => add(name)} title="добавить в позиции"
          style={{ marginRight: 6, width: 20, height: 20, lineHeight: '16px', padding: 0, borderRadius: 4, border: '1px solid rgba(128,128,128,.5)', background: 'transparent', color: 'inherit', cursor: 'pointer' }}>+</button>
  );
  const dates = data ? data.dates : [];
  const idx = day ? dates.indexOf(day) : -1;
  let rows = [];
  if (data) {
    rows = mode === 'day'
      ? (day ? data.clusters.filter(c => c.byDay[day] || c.excluded).map(c => ({ cluster: c.cluster, views: 0, clicks: 0, baskets: 0, orders: 0, spend: 0, avg_pos: null, ...(c.byDay[day] || {}) })) : [])
      : data.clusters.slice();
  }
  const qq = q.trim().toLowerCase();
  if (qq) rows = rows.filter(r => r.cluster.includes(qq));
  rows.sort((a, b) => (!!EX[a.cluster] !== !!EX[b.cluster] ? (EX[a.cluster] ? 1 : -1) : sort.key === 'cluster'
    ? sort.dir * a.cluster.localeCompare(b.cluster, 'ru')
    : sort.dir * (val(a, sort.key) - val(b, sort.key))));
  let weekRows = [];
  const wd = [];
  if (mode === 'week') {
    const endD = yesterday();
    for (let i = 6; i >= 0; i--) wd.push(new Date(Date.parse(endD + 'T00:00:00Z') - i * 86400000).toISOString().slice(0, 10));
    weekRows = rows.map(r => ({ ...r, ...aggr([r], wd) })).filter(r => r.views > 0 || r.orders > 0 || EX[r.cluster]);
    weekRows.sort((a, b) => (!!EX[a.cluster] !== !!EX[b.cluster] ? (EX[a.cluster] ? 1 : -1)
      : sort.key === 'cluster' ? sort.dir * a.cluster.localeCompare(b.cluster, 'ru')
      : sort.dir * (val(a, sort.key) - val(b, sort.key))));
    rows = [];
  }
  const renderGroup = (key, nameNode, freqNode, dayOf, tot, ex, head) => (
    <Fragment key={key}>
      <tr key="sp"><td colSpan={3 + wd.length + 1} style={{ padding: 0, height: 10, border: 'none' }}></td></tr>
      {WCOLS.map(([k, l], i) => {
        const first = i === 0;
        const bt = first ? GROUP_B : undefined;
        return (
          <tr key={k} style={{ opacity: ex ? .55 : 1, fontWeight: head ? 600 : 400 }}>
            {first && <td rowSpan={WCOLS.length} style={{ ...c11, textAlign: 'left', whiteSpace: 'normal', verticalAlign: 'top', borderTop: GROUP_B, maxWidth: 260, fontWeight: 600, background: 'rgba(128,128,128,.12)' }}>{nameNode}</td>}
            {first && <td rowSpan={WCOLS.length} style={{ ...c11, verticalAlign: 'top', borderTop: GROUP_B }}>{freqNode}</td>}
            <td style={{ ...c11, textAlign: 'left', opacity: .7, borderTop: bt }}>{l}</td>
            {wd.map((d, j) => {
              const x = dayOf(d);
              return (
                <td key={d} style={{ ...c11, borderTop: bt }}>
                  {x ? show(x, k) : '—'}
                </td>
              );
            })}
            <td style={{ ...c11, fontWeight: 600, borderTop: bt }}>{show(tot, k)}</td>
          </tr>
        );
      })}
    </Fragment>
  );
  const tot = rows.reduce((t, r) => ({
    views: t.views + r.views, clicks: t.clicks + r.clicks, baskets: t.baskets + r.baskets,
    orders: t.orders + r.orders, spend: t.spend + r.spend,
  }), { views: 0, clicks: 0, baskets: 0, orders: 0, spend: 0 });
  const dRev = dates.slice().reverse();
  const th = (k, label, left) => (
    <th key={k} onClick={() => setSort(s => ({ key: k, dir: s.key === k ? -s.dir : -1 }))}
      style={{ ...cell, textAlign: left ? 'left' : 'right', cursor: 'pointer', fontWeight: 600, userSelect: 'none' }}>
      {label}{sort.key === k ? (sort.dir < 0 ? ' ↓' : ' ↑') : ''}
    </th>
  );

  return (
    <div style={alwaysOpen ? { marginTop: 8 } : { marginTop: 10, border: '1px solid rgba(128,128,128,.3)', borderRadius: 10, padding: '8px 12px' }}>
      {!alwaysOpen && (
        <div onClick={() => setOpen(o => !o)} style={{ cursor: 'pointer', fontWeight: 600 }}>
          {open ? '▾' : '▸'} 📊 Статистика по ключам WB
        </div>
      )}
      {open && (
        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
            <button onClick={() => setMode('day')} style={btn(mode === 'day')}>День</button>
            <button onClick={() => setMode('week')} style={btn(mode === 'week')}>7 дней</button>
            <button onClick={() => setMode('period')} style={btn(mode === 'period')}>Период</button>
            {mode === 'day' && (
              <>
                <button disabled={idx <= 0} onClick={() => setDay(dates[idx - 1])} style={{ ...btn(false), opacity: idx <= 0 ? .4 : 1 }}>‹</button>
                <span style={{ minWidth: 110, textAlign: 'center', fontWeight: 600 }}>
                  {day ? fmtD(day) + (day === yesterday() ? ' (вчера)' : '') : '—'}
                </span>
                <button disabled={idx < 0 || idx >= dates.length - 1} onClick={() => setDay(dates[idx + 1])}
                  style={{ ...btn(false), opacity: (idx < 0 || idx >= dates.length - 1) ? .4 : 1 }}>›</button>
              </>
            )}
            {mode === 'period' && PERIODS.map(p => (
              <button key={p} onClick={() => setDays(p)} style={btn(days === p)}>{p} дн.</button>
            ))}
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="поиск по ключу"
              style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid rgba(128,128,128,.4)', background: 'transparent', color: 'inherit' }} />
            <button onClick={load} style={btn(false)}>↻</button>
          </div>
          {msg && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 6 }}>{msg}</div>}
          {err && <div style={{ color: '#ef4444' }}>{err}</div>}
          {loading && <div style={{ opacity: .7 }}>Загрузка…</div>}
          {!loading && data && dates.length === 0 && (
            <div style={{ opacity: .75, fontSize: 13 }}>
              Данных пока нет. Статистика собирается раз в день расширением: нужен хотя бы один ключ в «Позициях» у этого артикула,
              открытый кабинет рекламы и обновлённое расширение. Накопление идёт с момента обновления.
            </div>
          )}
          {!loading && data && dates.length > 0 && mode === 'week' && (
            <>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginBottom: 6, fontSize: 12 }}>
                <span style={{ opacity: .7 }}>Сортировка:</span>
                {WSORT.map(([k, l]) => (
                  <button key={k} onClick={() => setSort({ key: k, dir: -1 })} style={{ ...btn(sort.key === k), padding: '1px 8px', fontSize: 12 }}>{l}</button>
                ))}
              </div>
              {weekRows.length === 0
                ? <div style={{ opacity: .75, fontSize: 13 }}>За эти 7 дней по артикулу нет кластеров с показами.</div>
                : (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ borderCollapse: 'collapse', fontSize: 11, width: '100%', fontVariantNumeric: 'tabular-nums' }}>
                      <thead>
                        <tr>
                          <th style={{ ...c11, textAlign: 'left' }}>Ключ</th>
                          <th style={c11}>Частота</th>
                          <th style={c11}></th>
                          {wd.map(d => <th key={d} style={{ ...c11, fontWeight: 600 }}>{fmtD(d)}</th>)}
                          <th style={{ ...c11, fontWeight: 600 }}>Итого</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderGroup('total', 'Итого (' + weekRows.length + ')', '—', d => aggr(weekRows, [d]), aggr(weekRows, wd), false, true)}
                        {weekRows.map(r => {
                          const ex = !!EX[r.cluster];
                          return renderGroup(
                            r.cluster,
                            <>
                              {plus(r.cluster)}
                              <span style={ex ? { textDecoration: 'line-through' } : null} title={ex ? 'исключён в WB' : undefined}>{r.cluster}</span>
                            </>,
                            show(r, 'freq'),
                            d => r.byDay[d],
                            r,
                            ex,
                            false
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
            </>
          )}
          {!loading && data && dates.length > 0 && rows.length === 0 && mode !== 'week' && (
            <div style={{ opacity: .75, fontSize: 13 }}>За этот день по артикулу нет кластеров с показами.</div>
          )}
          {!loading && data && rows.length > 0 && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ borderCollapse: 'collapse', fontSize: 13, width: '100%' }}>
                <thead>
                  <tr>
                    {th('cluster', 'Ключ (кластер WB)', true)}
                    {COLS.map(([k, l]) => th(k, l))}
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ fontWeight: 600 }}>
                    <td style={{ ...cell, textAlign: 'left' }}>Итого ({rows.length})</td>
                    <td style={cell}>—</td><td style={cell}>{n0(tot.views)}</td><td style={cell}>{n0(tot.clicks)}</td>
                    <td style={cell}>{ctrOf(tot.clicks, tot.views)}</td><td style={cell}>{n0(tot.baskets)}</td>
                    <td style={cell}>{n0(tot.orders)}</td><td style={cell}>{n2(tot.spend)}</td><td style={cell}>—</td>
                  </tr>
                  {rows.map(r => (
                    <Fragment key={r.cluster}>
                      <tr>
                        <td style={{ ...cell, textAlign: 'left', whiteSpace: 'normal' }}>
                          {plus(r.cluster)}
                          {mode === 'period' && (
                            <span onClick={() => setExp(e => ({ ...e, [r.cluster]: !e[r.cluster] }))} style={{ cursor: 'pointer', marginRight: 6, opacity: .7 }}>{exp[r.cluster] ? '▾' : '▸'}</span>
                          )}
                          <span style={EX[r.cluster] ? { textDecoration: 'line-through', opacity: .55 } : null} title={EX[r.cluster] ? 'исключён в WB' : undefined}>{r.cluster}</span>
                        </td>
                        {COLS.map(([k]) => <td key={k} style={cell}>{show(r, k)}</td>)}
                      </tr>
                      {mode === 'period' && exp[r.cluster] && dRev.map(d => {
                        const x = r.byDay[d];
                        return (
                          <tr key={r.cluster + d} style={{ background: 'rgba(59,130,246,.05)', fontSize: 12 }}>
                            <td style={{ ...cell, textAlign: 'left', paddingLeft: 28, opacity: .85 }}>{fmtD(d)}</td>
                            {COLS.map(([k]) => <td key={k} style={cell}>{x ? show(x, k) : '—'}</td>)}
                          </tr>
                        );
                      })}
                    </Fragment>
                  ))}
                </tbody>
              </table>
              <div style={{ opacity: .6, fontSize: 12, marginTop: 6 }}>
                Цифры кластера целиком, как в кабинете WB (в кластер входят и похожие запросы). Показано не больше 100 кластеров.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
